"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAccumulationRuleset = getAccumulationRuleset;
const adapter_1 = require("../thresholds/adapter");
function getAccumulationRuleset(query) {
    const { state, ...ctx } = query;
    return (0, adapter_1.resolveAccumulation)(state, ctx);
}
//# sourceMappingURL=getAccumulationRuleset.js.map